namespace TabAurous {
    export interface EstimationRequest extends Serenity.ServiceRequest {
        Items?: TabAurous.Retail.POSQuotationItemsRow[];
        VoucherNo?: string;
        VoucherDate?: string;
        CustomerName?: string;
        IsPDF?: boolean;
    }
}
